module.exports = __webpack_public_path__ + "img/15.dcd8bfac.png";